<script>
import styleHOCFactory from './utils';
export default styleHOCFactory();
</script>

<style module>
@import 'styles/variables.css';

._linkstyle {
  composes: fw6 underline green _collision from global;
  &:hover {
    color: white;
  }
}
</style>
